import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { AiOutlineDelete, AiOutlineExclamationCircle } from "react-icons/ai";

import useStore from "../../store";
import api from "../../services/api";

export default () => {
  const [values, setValues] = useState({
    category: "VISIT",
    discount: 0,
    visa_fee: 0,
    embassy_fee: 0,
    appointment_fee: 0,
    hotel_fee: 0,
    ticket_fee: 0,
    insurance_fee: 0,
    advance: 0,
    expense: 0,
  });

  const { user } = useStore();

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (
        new Date(values.passport_issue_at).getTime() >=
        new Date(values.passport_expiry_at).getTime()
      ) {
        return toast.error("Passport expiry date in incorrect");
      }

      values.updated_by = user.username;
      values.created_by = user.username;
      values.total_amount = totalAmount;
      const { data } = await api.post("customer", values);

      if (values.advance > 0) {
        const obj = {};
        obj.created_by = user.username;
        obj.description = "Advance payment";
        obj.type = "Advance payment";
        obj.amount = values.advance;
        obj.method = "CASH";
        obj.customer_id = data.id;
        obj.customer_name = data.name;
        await api.post("payment", obj);
      }

      toast.success("Created!");
      setValues(data);
      navigate(`/customer/${data.id}`);
    } catch (error) {
      console.error(error);
    }
  };

  const totalAmount =
    parseInt(values.visa_fee || 0) +
    parseInt(values.embassy_fee || 0) +
    parseInt(values.appointment_fee || 0) +
    parseInt(values.hotel_fee || 0) +
    parseInt(values.ticket_fee || 0) +
    parseInt(values.insurance_fee || 0) +
    (values?.services || [])?.reduce(
      (acc, service) => acc + Number(service.fee),
      0
    );

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-6 flex items-center space-x-3">
        Customer Information
      </h1>
      <div className="bg-white shadow-lg rounded-lg p-6">
        <form onSubmit={handleSubmit}>
          {/* Section 1: Personal Details */}
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-6">
              Primary Details
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Full Name
                </label>
                <input
                  type="text"
                  id="name"
                  value={values.name}
                  onChange={(e) =>
                    setValues({ ...values, name: e.target.value })
                  }
                  placeholder="Enter name"
                  className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="phone"
                  className="block text-sm font-medium text-gray-700"
                >
                  Phone
                </label>
                <input
                  type="tel"
                  id="phone"
                  value={values.phone}
                  onChange={(e) =>
                    setValues({ ...values, phone: e.target.value })
                  }
                  placeholder="Enter phone number"
                  className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="address"
                  className="block text-sm font-medium text-gray-700"
                >
                  Address
                </label>
                <input
                  type="text"
                  id="address"
                  value={values.address}
                  onChange={(e) =>
                    setValues({ ...values, address: e.target.value })
                  }
                  placeholder="Enter address"
                  className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="category"
                  className="block text-sm font-medium text-gray-700"
                >
                  Category
                </label>
                <select
                  id="category"
                  className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                  value={values.category}
                  onChange={(e) =>
                    setValues({ ...values, category: e.target.value })
                  }
                >
                  <option value="">Select</option>
                  <option value="STUDY">Study Visa</option>
                  <option value="VISIT">Visit Visa</option>
                  <option value="OTHER">Other</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-6">
              <div>
                <label
                  htmlFor="passportNumber"
                  className="block text-sm font-medium text-gray-700"
                >
                  Passport Number
                </label>
                <input
                  type="text"
                  id="passportNumber"
                  value={values.passport}
                  onChange={(e) =>
                    setValues({ ...values, passport: e.target.value })
                  }
                  placeholder="Enter passport"
                  className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="passportIssue"
                  className="block text-sm font-medium text-gray-700"
                >
                  Issue Date (PKR)
                </label>
                <input
                  type="date"
                  id="passportIssue"
                  max={values?.passport_expiry_at}
                  value={values?.passport_issue_at}
                  onChange={(e) =>
                    setValues({
                      ...values,
                      passport_issue_at: e.target.value,
                    })
                  }
                  className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="passportExpiry"
                  className="block text-sm font-medium text-gray-700"
                >
                  Expiry Date (PKR)
                </label>
                <input
                  type="date"
                  id="passportExpiry"
                  min={values?.passport_issue_at}
                  value={values.passport_expiry_at}
                  onChange={(e) =>
                    setValues({
                      ...values,
                      passport_expiry_at: e.target.value,
                    })
                  }
                  className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                  required
                />
              </div>
            </div>
            {willExpireInMonths(values?.passport_expiry_at) && (
              <p className="text-red-600 text-xs pt-2 flex items-center font-bold justify-end">
                <AiOutlineExclamationCircle className="text-base mr-1" />
                Passport About To Expire
              </p>
            )}
          </div>

          <AddApplicants
            value={values?.applicants || []}
            onChange={(applicants) => setValues({ ...values, applicants })}
          />

          <h2 className="text-xl font-semibold text-gray-800 my-4">Services</h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            <div>
              <label
                htmlFor="visa_fee"
                className="block text-sm font-medium text-gray-700"
              >
                Visa Consultancy Fee (PKR)
              </label>
              <input
                type="number"
                min={0}
                id="visa_fee"
                value={values.visa_fee}
                onChange={(e) =>
                  setValues({ ...values, visa_fee: e.target.value })
                }
                placeholder="Enter Visa consultancy fee"
                className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
              />
            </div>
            <div>
              <label
                htmlFor="embassy_fee"
                className="block text-sm font-medium text-gray-700"
              >
                Embassy Fee (PKR)
              </label>
              <input
                type="number"
                min={0}
                id="embassy_fee"
                value={values.embassy_fee}
                onChange={(e) =>
                  setValues({ ...values, embassy_fee: e.target.value })
                }
                placeholder="Enter Embassy fee"
                className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
              />
            </div>
            <div>
              <label
                htmlFor="appointment_fee"
                className="block text-sm font-medium text-gray-700"
              >
                Appointment Reservation Fee (PKR)
              </label>
              <input
                type="number"
                min={0}
                id="appointment_fee"
                value={values.appointment_fee}
                onChange={(e) =>
                  setValues({ ...values, appointment_fee: e.target.value })
                }
                placeholder="Enter Appointment reservation fee"
                className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
              />
            </div>
            <div>
              <label
                htmlFor="hotel_fee"
                className="block text-sm font-medium text-gray-700"
              >
                Hotel Booking Charges (PKR)
              </label>
              <input
                type="number"
                min={0}
                id="hotel_fee"
                value={values.hotel_fee}
                onChange={(e) =>
                  setValues({ ...values, hotel_fee: e.target.value })
                }
                placeholder="Enter Hotel booking"
                className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
              />
            </div>
            <div>
              <label
                htmlFor="ticket_fee"
                className="block text-sm font-medium text-gray-700"
              >
                Ticket Fee (PKR)
              </label>
              <input
                type="number"
                min={0}
                id="ticket_fee"
                value={values.ticket_fee}
                onChange={(e) =>
                  setValues({ ...values, ticket_fee: e.target.value })
                }
                placeholder="Enter Ticket fee"
                className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
              />
            </div>
            <div>
              <label
                htmlFor="insurance_fee"
                className="block text-sm font-medium text-gray-700"
              >
                Insurance Fee (PKR)
              </label>
              <input
                type="number"
                min={0}
                id="insurance_fee"
                value={values.insurance_fee}
                onChange={(e) =>
                  setValues({ ...values, insurance_fee: e.target.value })
                }
                placeholder="Enter Insurance fee"
                className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
              />
            </div>
            <div>
              <label
                htmlFor="total"
                className="block text-sm font-medium text-gray-700"
              >
                Total Amount (PKR)
              </label>
              <input
                type="number"
                id="total"
                readOnly
                disabled
                value={totalAmount}
                className="text-lg font-bold mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm px-4 py-1"
              />
            </div>
            <div>
              <label
                htmlFor="discount"
                className="block text-sm font-medium text-gray-700"
              >
                Discount (PKR)
              </label>
              <input
                type="number"
                id="discount"
                value={values.discount}
                onChange={(e) =>
                  setValues({ ...values, discount: e.target.value })
                }
                className="text-lg mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm px-4 py-1"
              />
            </div>
            <div>
              <label
                htmlFor="total"
                className="block text-sm font-medium text-gray-700"
              >
                Total Net Amount (PKR)
              </label>
              <input
                type="number"
                id="total"
                readOnly
                disabled
                value={totalAmount - values.discount}
                className="text-lg font-bold mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm px-4 py-1"
              />
            </div>
            <div>
              <label
                htmlFor="advance"
                className="block text-sm font-medium text-gray-700"
              >
                Advance Payment (PKR)
              </label>
              <input
                type="number"
                min={0}
                id="advance"
                value={values.advance}
                onChange={(e) =>
                  setValues({ ...values, advance: e.target.value })
                }
                placeholder="Enter Advance"
                className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
              />
            </div>
            <div>
              <label
                htmlFor="advance"
                className="block text-sm font-medium text-gray-700"
              >
                Balance (PKR)
              </label>
              <input
                type="number"
                min={0}
                readOnly
                disabled
                value={totalAmount - values.discount - parseInt(values.advance || 0)}
                placeholder="Enter Advance"
                className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
              />
            </div>
          </div>
         
          <div className="grid grid-cols-3 gap-6 pb-6">
            {user.role === "admin" && (
              <>
                <div>
                  <label
                    htmlFor="expense"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Expense (PKR)
                  </label>
                  <input
                    type="number"
                    id="expense"
                    onChange={(e) =>
                      setValues({ ...values, expense: e.target.value })
                    }
                    value={values.expense}
                    className="text-lg mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm px-4 py-1"
                  />
                </div>
                <div>
                  <label
                    htmlFor="net"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Net Profit (PKR)
                  </label>
                  <input
                    type="number"
                    id="net"
                    readOnly
                    disabled
                    value={
                      totalAmount -
                      (values.discount || 0) -
                      (values.expense || 0) -
                      parseInt(values.advance || 0)
                    }
                    className="text-lg font-bold mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm px-4 py-1"
                  />
                </div>
              </>
            )}
          </div>

          <AddService
            value={values?.services || []}
            onChange={(services) => setValues({ ...values, services })}
          />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-6">
            <Assignee values={values} setValues={setValues} />
          </div>

          <div className="flex items-center justify-between mt-5">
            <div className="flex items-center space-x-2">
              <button
                type="submit"
                className="bg-black text-sm text-white px-6 py-2 rounded-md hover:bg-gray-900 transition"
              >
                Submit
              </button>
            </div>

            {/* <ViewInvoice payment={{}} customer={values} /> */}
          </div>
        </form>
      </div>
    </div>
  );
};

// a component to add multiple services to the customer with a button that creates empty fields for the user to fill in each row includes a button to remove the row

const AddService = ({ value, onChange }) => {
  const [services, setServices] = useState([{ name: "", fee: "" }]);

  useEffect(() => {
    setServices(value);
  }, []);

  const handleAddService = () => {
    setServices([...services, { name: "", fee: "" }]);
  };

  const handleRemoveService = (index) => {
    if (!window.confirm("Are you sure ?")) return;
    const newServices = services.filter((_, i) => i !== index);
    setServices(newServices);
    onChange(newServices);
  };

  const handleChange = (evt, index, field) => {
    const newServices = [...services];
    newServices[index][field] = evt.target.value;
    setServices(newServices);
    onChange(newServices);
  };

  return (
    <div className="mb-8">
      <div className="flex items-center mb-5">
        <h2 className="text-xl font-semibold text-gray-800 mr-4">Others</h2>
        <button
          type="button"
          onClick={handleAddService}
          className="text-blue-700 underline cursor-pointer text-xs"
        >
          Add New Service
        </button>
      </div>

      <div className="space-y-2">
        {services.map((service, index) => (
          <div
            key={index}
            className="flex items-end w-full justify-stretch gap-6"
          >
            <div className="flex-1">
              <label
                htmlFor="service"
                className="block text-sm font-medium text-gray-700"
              >
                Service Description
              </label>
              <input
                type="text"
                id="service"
                value={service.name}
                onChange={(e) => handleChange(e, index, "name")}
                placeholder="Enter service"
                className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                required
              />
            </div>

            <div className="flex-1">
              <label
                htmlFor="Fee"
                className="block text-sm font-medium text-gray-700"
              >
                Fee
              </label>
              <input
                type="number"
                id="fee"
                min={0}
                value={service.fee}
                onChange={(e) => handleChange(e, index, "fee")}
                placeholder="Enter fee"
                className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                required
              />
            </div>

            <div className="flex items-center justify-end space-x-2">
              <button
                type="button"
                onClick={() => handleRemoveService(index)}
                className="bg-red-500 text-white p-3 rounded-md hover:bg-red-700"
              >
                <AiOutlineDelete />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const AddApplicants = ({ value, onChange }) => {
  const [applicants, setApplicants] = useState([
    { passport: "", passport_issue_at: "", passport_expiry_at: "" },
  ]);

  useEffect(() => {
    setApplicants(value);
  }, []);

  const handleAddApplicant = () => {
    setApplicants([
      ...applicants,
      { passport: "", passport_issue_at: "", passport_expiry_at: "" },
    ]);
  };

  const handleRemoveApplicant = (index) => {
    if (!window.confirm("Are you sure ?")) return;
    const newApplicants = applicants.filter((_, i) => i !== index);
    setApplicants(newApplicants);
    onChange(newApplicants);
  };

  const handleChange = (evt, index, field) => {
    const newApplicants = [...applicants];
    newApplicants[index][field] = evt.target.value;
    setApplicants(newApplicants);
    onChange(newApplicants);
  };

  return (
    <div className="mb-8">
      <div className="flex items-center mb-5 justify-end">
        <button
          type="button"
          onClick={handleAddApplicant}
          className="text-blue-700 underline cursor-pointer text-xs"
        >
          Add New Applicant
        </button>
      </div>

      <div className="space-y-2">
        {applicants.map((applicant, index) => (
          <div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-6">
              <div>
                <label
                  htmlFor="passportNumber"
                  className="block text-sm font-medium text-gray-700"
                >
                  Passport Number
                </label>
                <input
                  type="text"
                  id="passportNumber"
                  value={applicant.passport}
                  onChange={(e) => handleChange(e, index, "passport")}
                  placeholder="Enter passport"
                  className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="passportIssue"
                  className="block text-sm font-medium text-gray-700"
                >
                  Issue Date
                </label>
                <input
                  type="date"
                  id="passportIssue"
                  max={applicant?.passport_expiry_at}
                  value={applicant?.passport_issue_at}
                  onChange={(e) => handleChange(e, index, "passport_issue_at")}
                  className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="passportExpiry"
                  className="block text-sm font-medium text-gray-700"
                >
                  Expiry Date
                </label>
                <div className="flex items-center space-x-1 mt-1">
                  <input
                    type="date"
                    id="passportExpiry"
                    min={applicant?.passport_issue_at}
                    value={applicant.passport_expiry_at}
                    onChange={(e) =>
                      handleChange(e, index, "passport_expiry_at")
                    }
                    className="block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => handleRemoveApplicant(index)}
                    className="bg-red-500 text-white p-3 rounded-md hover:bg-red-700"
                  >
                    <AiOutlineDelete />
                  </button>
                </div>
              </div>
            </div>
            {willExpireInMonths(applicant?.passport_expiry_at) && (
              <p className="text-red-600 text-xs pt-2 flex items-center font-bold justify-end">
                <AiOutlineExclamationCircle className="text-base mr-1" />
                Passport Is About To Expire
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const Assignee = ({ values, setValues }) => {
  const [users, setUsers] = useState();

  const { user } = useStore();

  useEffect(() => {
    setValues({ ...values, assignee: user.username });

    if (user.role !== "admin") {
      setUsers([user]);
      return;
    }
    getUsers();
  }, [user]);

  const getUsers = async (e) => {
    try {
      const obj = {};
      if (user.role !== "admin") obj.username = user.username;
      const { data } = await api.post("user/search", obj);
      setUsers(data.users);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <label
        htmlFor="assignee"
        className="block text-sm font-medium text-gray-700"
      >
        Assignee
      </label>

      <select
        id="assignee"
        className="mt-1 block w-full uppercase rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
        value={values.assignee}
        onChange={(e) => setValues({ ...values, assignee: e.target.value })}
        disabled={!users}
      >
        {!users && <option value="">Loading...</option>}
        <option value="" disabled>
          Select
        </option>
        {(users || []).map((user) => (
          <option key={user.id} value={user.username}>
            {user.name}
          </option>
        ))}
      </select>
    </div>
  );
};

function willExpireInMonths(expiryDate) {
  if (!expiryDate) return;
  // Current date
  const currentDate = new Date();

  // Calculate the target date after '9'
  const targetDate = new Date();
  targetDate.setMonth(currentDate.getMonth() + 9);

  // Convert expiryDate to a Date object if it's a string
  const expiry = new Date(expiryDate);

  // Check if expiry date is within the target range
  return expiry <= targetDate && expiry >= currentDate;
}
